import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import Button from '../Core/Button';
import i18n from '../../i18n';
import moment from 'moment';

function EventFilterModal({
  show,
  onHide,
  events,
  selectedEventIds,
  onApplyFilter,
}) {
  const [localSelectedEventIds, setLocalSelectedEventIds] = useState([]);

  useEffect(() => {
    setLocalSelectedEventIds([...selectedEventIds]);
  }, [selectedEventIds, show]);

  const toggleEventSelection = (eventID) => {
    if (localSelectedEventIds.includes(eventID)) {
      setLocalSelectedEventIds(
        localSelectedEventIds.filter((id) => id !== eventID),
      );
    } else {
      setLocalSelectedEventIds([...localSelectedEventIds, eventID]);
    }
  };

  const handleApply = () => {
    onApplyFilter(localSelectedEventIds);
    onHide();
  };

  return (
    <Modal
      className="event-filter-modal"
      show={show}
      size="lg"
      aria-labelledby="event-filter-modal"
      centered
      dialogClassName="info-modal"
      onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          <h3>{i18n.t('EVENTFILTER')}</h3>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="event-list-container">
          {events &&
            events.map((event) => (
              <div key={event.eventID} className="event-item">
                <label className="event-checkbox">
                  <input
                    type="checkbox"
                    checked={localSelectedEventIds.includes(event.eventID)}
                    onChange={() => toggleEventSelection(event.eventID)}
                  />
                  <div className="checkbox-custom">
                    {localSelectedEventIds.includes(event.eventID) && (
                      <div className="check-icon">✓</div>
                    )}
                  </div>
                  <div className="event-details">
                    <h5>{event.eventName}</h5>
                    <div className="event-meta">
                      <span className="event-date">
                        {moment(event.firstJobDate).format('DD.MM.YYYY')}
                      </span>
                      <span>|</span>
                      <span className="event-job-types">
                        {event.jobNames.join(', ')}
                      </span>
                    </div>
                  </div>
                </label>
              </div>
            ))}
        </div>
        <div className="action-buttons">
          <Button
            className="btn btn-primary"
            label={i18n.t('ÜBERNEHMEN')}
            onClick={handleApply}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default EventFilterModal;
